(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller(
      "CompanyApprovalPaymentLogListV2",
      CompanyApprovalPaymentLogListV2
    );

  CompanyApprovalPaymentLogListV2.$inject = ["$timeout", "$state"];

  function CompanyApprovalPaymentLogListV2($timeout, $state) {
    function loadCompanyApprocalPaymentLogs() {
      var approvalPaymentLogsEl = document.getElementById("payment-logs");
      approvalPaymentLogsEl.addEventListener("prevPageBtn", function () {
        $state.go("supplierPanel-v2.companyPaymentLogList");
      });
      approvalPaymentLogsEl.addEventListener("backToPrevVersion", function () {
        $state.go("supplierPanel-v2.companyApprovalPaymentLogList", {
          type: "services",
        });
      });
      approvalPaymentLogsEl.addEventListener("trigger-edit-order-bag",function (e) {
          var orderBagId = e.detail[0];
          $state.go("supplierPanel-v2.editOrderBag", { id: orderBagId });
        }
      );
      approvalPaymentLogsEl.addEventListener("trigger-edit-invoice", function (e) {
        var invoiceId = e.detail[0];
        $state.go("supplierPanel-v2.invoiceInfoDetail", { id: invoiceId });
      });
    }
    $timeout(loadCompanyApprocalPaymentLogs, 100);
  }
})();
